/** True when Firebase Auth user signed in with phone (mobile app or web phone OTP). */
export function userHasPhoneCredential(user) {
  if (!user) return false;
  if (user.phoneNumber) return true;
  return (user.providerData || []).some((p) => p.providerId === 'phone');
}

export function normalizePhoneInput(raw) {
  const digits = (raw || '').replace(/\D/g, '');
  if ((raw || '').startsWith('+')) return `+${digits}`;
  if (digits.length === 10) return `+91${digits}`;
  return digits ? `+${digits}` : '';
}

export function phoneLinkConflictMessage() {
  return (
    'This phone number is already registered with the SuperOwl mobile app. ' +
    'Sign out, open the login page, and choose Sign in with Phone using the same number.'
  );
}

export function googleLinkConflictMessage() {
  return (
    'This Gmail is already tied to another SuperOwl account. Sign out, choose Sign in with Google, ' +
    'then verify the same phone number you use in the mobile app.'
  );
}
